import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "../About/Github";
import Techstack from "../About/Techstack";
import Aboutcard from "../About/AboutCard";
import Toolstack from "../About/Toolstack";

import myImg from "../../Assets/logo-img2.jpg";
// badge images
import awsqst from "../../Assets/cloud-badges/cloud-quest.png";
import awsess from "../../Assets/cloud-badges/cloud-essentials.png";
import awsops from "../../Assets/cloud-badges/cloud-ops.png";
import awscompute from "../../Assets/cloud-badges/cloud-compute.png";
import awsdb from "../../Assets/cloud-badges/cloud-db.png";
import awsintro from "../../Assets/cloud-badges/cloud-intro.png";
import awsnetworking from "../../Assets/cloud-badges/cloud-networking.png";
import awssecurity from "../../Assets/cloud-badges/cloud-security.png";
import awsstorage from "../../Assets/cloud-badges/cloud-storage.png";
import awscp from "../../Assets/cloud-badges/cloud-practitioner.png";
import awssls from "../../Assets/cloud-badges/cloud-serverless.png";
import awssol from "../../Assets/cloud-badges/solution-architect.png";
import awsquestsol from "../../Assets/cloud-badges/quest-solution-architect.png";
import awsquestdev from "../../Assets/cloud-badges/serverless-developer.png";
import awsdev from "../../Assets/cloud-badges/developer-associate.png";
import awsai from "../../Assets/cloud-badges/ai-practitioner.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { BsYoutube } from "react-icons/bs";

function Home() {
  const certifications = [
    {
      title: "AWS Certified Developer – Associate",
      image: awsdev,
      link: "https://www.credly.com/badges/fd3a9d39-0e2e-4b08-9d9f-cff75dea069d/public_url"
    },
    {
      title: "AWS Certified Solutions Architect – Associate",
      image: awssol,
      link: "https://www.credly.com/badges/ad90700c-7390-4707-bb03-95050324f9d4/public_url"
    },
    {
      title: "AWS Certified AI Practitioner",
      image: awsai,
      link: "https://www.credly.com/badges/e2793878-9401-46c0-9247-679d542391b2/public_url"
    },
    {
      title: "AWS Certified Cloud Practitioner",
      image: awscp,
      link: "https://www.credly.com/badges/1f60e5db-f4b1-43bf-bdc9-c49118c2b670/public_url"
    },
  ];

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
      </Container>
      
      {/* Main Home Content */}
      <Container fluid className="home-about-section" id="about">
        <Container>
          {/* Intro section with profile picture */}
          <Row>
            <Col md={8} className="home-about-description">
              <h1 style={{ fontSize: "2.6em" }}>
                Hey, <span className="purple"> I'm Gedion </span> 👋🏻
              </h1>
              <p className="home-about-body">
                I'm a problem solver who enjoys learning and sharing knowledge.
                <br />
                <br />
                My fields of interest include building new &nbsp;
                <i>
                  <b className="purple">Web Technologies and Products </b> as well as cloud computing with {" "}
                  <b className="purple">
                    AWS.
                  </b>
                </i>
                <br />
                <br />
                I also apply my passion for developing products
                with <b className="purple">Node.js</b> and
                <i>
                  <b className="purple">
                    {" "}
                    Modern Javascript Library and Frameworks
                  </b>
                </i>
                &nbsp; like
                <i>
                  <b className="purple"> React.js and Next.js</b>
                </i>
              </p>
            </Col>
            <Col md={4} className="myAvtar">
              <Tilt>
                <img
                  src={myImg}
                  className="img-fluid"
                  alt="avatar"
                  style={{
                    borderRadius: '50%',
                    width: '240px',
                    height: '240px',
                    objectFit: 'cover',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)'
                  }}
                />
              </Tilt>
            </Col>
          </Row>

          {/* About Card Section */}
          <Row style={{ justifyContent: "center", padding: "50px 10px" }}>
            <Col md={12}>
              <h1 style={{ fontSize: "2.6em", paddingBottom: "20px", textAlign: "center" }}>
                Know Who <strong className="purple">I'M</strong>
              </h1>
              <Aboutcard />
            </Col>
          </Row>

          {/* AWS Community Builder Section */}
          <Row className="aws-community-section" style={{ marginBottom: "3rem", marginTop: "2rem" }}>
            <Col md={12} style={{ textAlign: "center" }}>
              <h2 style={{ fontSize: "2.2em", marginBottom: "1.5rem" }}>
                <span className="purple">AWS Community Builder</span>
              </h2>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "1.5rem" }}>
                <img
                  src="https://d2908q01vomqb2.cloudfront.net/da4b9237bacccdf19c0760cab7aec4a8359010b0/2020/07/23/AWS-CBs-blog-image.png"
                  alt="AWS Community Builder"
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)"
                  }}
                />
              </div>
              <p style={{ 
                maxWidth: "600px", 
                margin: "0 auto", 
                fontSize: "1.1em", 
                lineHeight: "1.6",
                color: "white",
                textAlign: "justify"
              }}>
                Proud to be part of the <b className="purple">AWS Community Builders</b> program, 
                where I share knowledge, contribute to the cloud community, and help others 
                on their AWS journey. This recognition reflects my commitment to continuous 
                learning and community engagement in cloud technologies.
              </p>
            </Col>
          </Row>

          {/* Certifications Section */}
          <Row className="certification-section" style={{ marginBottom: "3rem", marginTop: "2rem" }}>
            <Col md={12}>
              <h1 style={{ fontSize: "2.6em", textAlign: "center", marginBottom: "0.5em" }}>
                <span className="purple">Certifications</span>
              </h1>
            </Col>
            <Row style={{ justifyContent: "center", gap: "10px" }}>
              {certifications.map((cert, index) => (
                <Col xs={6} md={3} lg={2} className="certification-card" key={index}>
                  <a href={cert.link} target="_blank" rel="noreferrer" className="certification-link">
                    <img
                      src={cert.image}
                      alt={cert.title}
                      className="certification-image"
                      title={cert.title}
                    />
                  </a>
                </Col>
              ))}
            </Row>
          </Row>

          {/* Skills Section */}
          <h1 className="project-heading" style={{ textAlign: "center", marginTop: "3rem" }}>
            Professional <strong className="purple">Skillset </strong>
          </h1>
          <Techstack />

          <h1 className="project-heading" style={{ textAlign: "center", marginTop: "3rem" }}>
            <strong className="purple">Tools</strong> I use
          </h1>
          <Toolstack />

          {/* GitHub Activity */}
          <Github />

          {/* Social Links Section */}
          <Row style={{ marginTop: "3rem" }}>
            <Col md={12} className="home-about-social">
              <h1>FIND ME ON</h1>
              <p>
                Feel free to <span className="purple">connect </span>with me
              </p>
              <ul className="home-about-social-links">
                <li className="social-icons">
                  <a
                    href="https://github.com/Gediontkd"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <AiFillGithub />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://www.linkedin.com/in/gedion-daniel-760ba6280/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://www.youtube.com/@gediondev"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <BsYoutube />
                  </a>
                  </li>
                <li className="social-icons">
                  <a
                    href="https://www.instagram.com/gediondev/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <AiFillInstagram />
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Home;